<template lang="pug">
    div(class="company-logo-placeholder")
        img(:src="logoURL()" class="img" onerror="this.style.display='none'")
</template>

<script>
export default {
    name: "CompanyLogo",
    props: {
        company_id: Number
    },
    methods: {
        logoURL() {
            let imageUrl = `/images/logos/senofidk/${this.company_id}.jpg`;
            let http = new XMLHttpRequest();

            // console.log(http.open('HEAD', imageUrl, false));

            if(http.open('HEAD', imageUrl, false) !== undefined) {
                http.open('HEAD', imageUrl, false);
                http.send();

                if(http.status === 404) {
                    imageUrl = `/images/logos/senofidk/${this.company_id}.png`;
                    http = new XMLHttpRequest();

                    http.open('HEAD', imageUrl, false);
                    http.send();
                }

                return imageUrl;
            }

            return '';
        }
    }
}
</script>

<style scoped>

.company-logo-placeholder {
    float: right;
    width:25%;
    text-align: center;
    transition: opacity .3s;
}

.company-logo-placeholder .img {
    width: 120px;
}
</style>
